/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';
import type { ILogEntry } from '../../api/domain/logging/log-entry';
import { LogEntrySeverity } from '../../enum/log-entry-severity';

const createLogEntry = (message: string, severity: LogEntrySeverity): ILogEntry => ({
    browser: navigator.userAgent,
    currentUrl: window.location.href,
    message,
    severity,
    time: new Date().toISOString(),
});

enum LoggingApiActions {
    WRITE_LOG = 'logging-api.write-log',
    WRITE_LOG_SUCCESS = 'logging-api.write-log.success',
    WRITE_LOG_FAILURE = 'logging-api.write-log.failure',
}

export const writeLogEntry = createAction<ILogEntry>(LoggingApiActions.WRITE_LOG);
export const writeLogEntrySuccess = createAction(LoggingApiActions.WRITE_LOG_SUCCESS);
export const writeLogEntryFailure = createAction(LoggingApiActions.WRITE_LOG_FAILURE);

export const logTrace = (message: string) => writeLogEntry(createLogEntry(message, LogEntrySeverity.TRACE));
export const logDebug = (message: string) => writeLogEntry(createLogEntry(message, LogEntrySeverity.DEBUG));
export const logWarn = (message: string) => writeLogEntry(createLogEntry(message, LogEntrySeverity.WARN));
export const logInfo = (message: string) => writeLogEntry(createLogEntry(message, LogEntrySeverity.INFO));
export const logError = (message: string) => writeLogEntry(createLogEntry(message, LogEntrySeverity.ERROR));
